/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponse } from '../models/api-response';
import { getCatalogConfigByConversationRef } from '../fn/company-public-api/get-catalog-config-by-conversation-ref';
import { GetCatalogConfigByConversationRef$Params } from '../fn/company-public-api/get-catalog-config-by-conversation-ref';
import { getCompanyWaProfileImage } from '../fn/company-public-api/get-company-wa-profile-image';
import { GetCompanyWaProfileImage$Params } from '../fn/company-public-api/get-company-wa-profile-image';

@Injectable({ providedIn: 'root' })
export class CompanyPublicApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCompanyWaProfileImage()` */
  static readonly GetCompanyWaProfileImagePath = '/v1/api/ui/public/company/wa-profile/{wabaPhoneId}/image';

  /**
   * Get WhatsApp profile image.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyWaProfileImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWaProfileImage$Response(params: GetCompanyWaProfileImage$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return getCompanyWaProfileImage(this.http, this.rootUrl, params, context);
  }

  /**
   * Get WhatsApp profile image.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyWaProfileImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyWaProfileImage(params: GetCompanyWaProfileImage$Params, context?: HttpContext): Observable<Blob> {
    return this.getCompanyWaProfileImage$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getCatalogConfigByConversationRef()` */
  static readonly GetCatalogConfigByConversationRefPath = '/v1/api/ui/public/company/catalog-config/{conversationRef}';

  /**
   * Get Vitrine catalog config by conversation reference.
   *
   * Returns enriched catalog_config fields for the in-app checkout. CONTACT_ATTRIBUTE choices are limited to values already present on the conversation contact. HTML guide: GET /v1/api/ui/public/docs/catalog-config
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCatalogConfigByConversationRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCatalogConfigByConversationRef$Response(params: GetCatalogConfigByConversationRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponse>> {
    return getCatalogConfigByConversationRef(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Vitrine catalog config by conversation reference.
   *
   * Returns enriched catalog_config fields for the in-app checkout. CONTACT_ATTRIBUTE choices are limited to values already present on the conversation contact. HTML guide: GET /v1/api/ui/public/docs/catalog-config
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCatalogConfigByConversationRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCatalogConfigByConversationRef(params: GetCatalogConfigByConversationRef$Params, context?: HttpContext): Observable<ApiResponse> {
    return this.getCatalogConfigByConversationRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponse>): ApiResponse => r.body)
    );
  }

}
